export default class AssetIdError extends Error {
    constructor() {
        super('AssetId is not available.');
    }
}
